import { Component, input, output } from '@angular/core';
import { ToolParam } from '../../../../utils/models/tool.models';
import { TimelinePreviewComponent } from '../timeline-preview/timeline-preview.component';

@Component({
  selector: 'app-parameter-node',
  templateUrl: './parameter-node.component.html',
  styleUrls: ['./parameter-node.component.scss'],
  imports: [TimelinePreviewComponent],
})
export class ParameterNodeComponent {
  /** Inputs. */
  readonly data = input.required<Record<string, unknown> | Record<string, unknown>[]>();
  readonly parameters = input<ToolParam[]>([]);
  readonly interactive = input(false);

  /** Outputs. */
  readonly activated = output();
}
